import * as React from 'react';
import { BestDeterminer } from '../../lib/determiner';
import { BaseRow, BaseRowFactory } from '../BaseRow';

export class SchrodingerCatRow extends BaseRow<SchrodingerCatRowFactory> {
  renderData() {
    const len = this.props.data.alive.toLocaleString("en-US");
    return <>
      <span className="schrodinger-container">
        <span className="schrodinger-off">Among {this.props.input.attempt.toLocaleString("en-US")} observations, we found <span style={{
          position: "relative",
          display: "inline-block"
        }}>
          <span>{len.replace(/[0-9]/g, " ")}</span>
          <span style={{ position: "absolute", left: 0, opacity: 0.5 }}>{len.replace(/[0-9]/g, "0")}</span>
          <span style={{ position: "absolute", left: 0, opacity: 0.5 }}>{len.replace(/[0-9]/g, "1")}</span>
          <span style={{ position: "absolute", left: 0, opacity: 0.5 }}>{len.replace(/[0-9]/g, "2")}</span>
          <span style={{ position: "absolute", left: 0, opacity: 0.5 }}>{len.replace(/[0-9]/g, "3")}</span>
          <span style={{ position: "absolute", left: 0, opacity: 0.5 }}>{len.replace(/[0-9]/g, "4")}</span>
          <span style={{ position: "absolute", left: 0, opacity: 0.5 }}>{len.replace(/[0-9]/g, "5")}</span>
          <span style={{ position: "absolute", left: 0, opacity: 0.5 }}>{len.replace(/[0-9]/g, "6")}</span>
          <span style={{ position: "absolute", left: 0, opacity: 0.5 }}>{len.replace(/[0-9]/g, "7")}</span>
          <span style={{ position: "absolute", left: 0, opacity: 0.5 }}>{len.replace(/[0-9]/g, "8")}</span>
          <span style={{ position: "absolute", left: 0, opacity: 0.5 }}>{len.replace(/[0-9]/g, "9")}</span>
        </span> <span style={{
          position: "relative",
          display: "inline-block"
        }}>
          <span>alive <span style={{ opacity: 1 }}>😼</span></span>
          <span style={{
            position: "absolute", left: 0, top: 0
          }}>dead  <span style={{ opacity: 0.5 }}>🙀</span></span>
        </span>.</span>
        <span className="schrodinger-on">Among {this.props.input.attempt.toLocaleString("en-US")} observations, we found {this.props.data.alive.toLocaleString("en-US")} alive 😼 and {this.props.data.dead.toLocaleString("en-US")} dead 🙀.</span>
      </span>
    </>
  }
}

export class SchrodingerCatRowFactory extends BaseRowFactory<typeof SchrodingerCatRow, { alive: number, dead: number }, {
  attempt: number
}> {
  generate(input: this['TInput']) {
    const observations = new Array(input.attempt).fill(0).map((i) => BestDeterminer.integer(0, 1));
    const alive = observations.filter((i) => i === 1).length;
    return {
      alive: alive,
      dead: input.attempt - alive
    }
  }

  component = SchrodingerCatRow
}

